var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var EmailSubscriber = require('../../../../../include/_js/subscribe/EmailSubscriber');

        $(function () {
            function toggleLoading($loading, show) {
                $loading.toggleClass('hide', !show);
            }

            /**
             * @param isOpen - подписка с форма в модальном окне или на странице
             *      если на странице - нужно открыть модалку, если модалка - другое поведение
             *      TODO: чем не устроил bs3popup я не понял,
             *          там есть и прелоадер и ajax загрузка контента, и размеры...
             *          из-за анимации?
             *          Если текущая работа принципиальна: сделать это рядом с общей функцией.
             *          Модалка одна для всего сайта - а меняем оформление снаружи.
             */
            function subscriptionSuccess(isOpen) {
                var url = window.app.urls.addSubscriptionSuccess;

                var utils = window.bs3popupUtils;
                var $popup = utils.$getPopup();

                if (!isOpen) {
                    utils.setSize($popup, '570px', 'auto');
                    utils.toggleSubscribeSuccessTheme($popup, true);
                    utils.showBody($popup, '<p class="text-center"><img src="/img/load.gif" style="width: 16px" /></p>');
                    utils.show($popup, {
                        backdrop: true,
                        show: true
                    });
                } else {
                    utils.hideBody($popup);
                }
                $.get(url, {}, function (data) {
                    utils.showBody($popup, data);
                });
            }
            $('body').on('click', '.subscribe-btn', function (e) {
                e.preventDefault();
                var $block = $(this).closest('.subscription-control');
                var $email = $block.find('.subscription-email-validate');
                var emailValue = $email.val();
                var cityId = $block.find('.subscription-city-control').val();
                var $loading = $block.find('.subscription-loading');
                var isInModal = $(this).hasClass('popup-subscribe-btn');

                var subscriber = new EmailSubscriber(emailValue, cityId);

                if (!subscriber.validateEmail()) {
                    $email.focus();
                    $email.tooltip({
                        trigger: 'manual',
                        placement: 'top',
                        title: 'Введите свой e-mail!'
                    }).tooltip('show');
                    setTimeout(function () {
                        $email.tooltip('hide');
                    }, 2500);
                    return;
                }

                toggleLoading($loading, true);
                subscriber.subscribe(function (resultSubscribe) {
                    toggleLoading($loading, false);
                    if (resultSubscribe.success) {
                        subscriptionSuccess(isInModal);
                    } else {
                        $email.val('');
                        $email.prop('placeholder', resultSubscribe.message);
                        $email.focus();
                    }
                });
            });
        });
    }, { "../../../../../include/_js/subscribe/EmailSubscriber": 2 }], 2: [function (require, module, exports) {
        var EmailSubscriber = function () {
            function EmailSubscriber(email, cityId) {
                _classCallCheck(this, EmailSubscriber);

                /** @type {string} */
                this.email = email;

                /** @type {number} */
                this.cityId = Number(cityId);
            }

            _createClass(EmailSubscriber, [{
                key: "validateEmail",
                value: function validateEmail() {
                    return this.email !== '';
                }
            }, {
                key: "subscribe",
                value: function subscribe(callback) {
                    var resultData = {
                        success: false,
                        message: 'Произошла ошибка! Попробуйте позже.'
                    };

                    if (!this.validateEmail()) {
                        resultData.message = 'Введите свой e-mail';
                        callback(resultData);

                        return;
                    }

                    var params = {
                        email: this.email
                    };
                    if (this.cityId) {
                        params.city = this.cityId;
                    }

                    $.post(window.app.urls.addSubscription, params, function (response) {
                        if (response.success) {
                            window.tracking.setEvent(window.app.goals.HOT_OFFERS_SUBSCRIBE);
                            resultData.success = true;
                        }
                        resultData.message = response.message;

                        callback(resultData);
                    });
                }
            }]);

            return EmailSubscriber;
        }();

        module.exports = EmailSubscriber;
    }, {}] }, {}, [1]);